<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

body{
  width: 100%;
  height: 100%;
}

html{
  width: 100%;
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  width: 100%;
}

.form_ls{
  width: 100%;
}
.form_ls .el-form-item{
  margin-bottom: 30px;
}
.form_ls .el-form-item:last-child{
  margin-bottom: 20px;
}
.form_ls .el-input__inner {
  height: 50px;
  line-height: 50px;
  border: 1px solid #DBDCDC;
  border-left: 0px solid #fff;
}
.form_ls .el-input__inner:focus {
  border: 1px solid #DBDCDC;
  border-left: 0px solid #fff;
}
.form_ls  .el-input-group__prepend {
  background-color: #fff;
    color: #909399;
    border: 1px solid #DBDCDC;
    border-right: 0px solid #fff;
    padding: 0px 0px 0px 20px;
}
.form_ls  .el-input-group__prepend img{
   width: 21px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue